// extracted by mini-css-extract-plugin
export var borderbottom = "ParagraphHighlightedTextArea-module--borderbottom--e16c0";
export var bordersection = "ParagraphHighlightedTextArea-module--bordersection--f47bd";
export var image = "ParagraphHighlightedTextArea-module--image--37b08";
export var paragraphhighlightedtextareainner = "ParagraphHighlightedTextArea-module--paragraphhighlightedtextareainner--70900";
export var text = "ParagraphHighlightedTextArea-module--text--e2a07";
export var title = "ParagraphHighlightedTextArea-module--title--a362f headings-module--sectionHeading--a8f67";
export var titlewrapper = "ParagraphHighlightedTextArea-module--titlewrapper--e0acd";